var headerSlider = tns({
	container: '.image-slider',
	items: 1,
	mode: 'gallery',
	controls: false,
	navPosition: 'bottom',
	autoplay: true,
	autoplayButtonOutput: false
})
